import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Paragraph from '../../atoms/Paragraph';
import Author from '../../molecules/message/Author';
import Flex from '../../atoms/Flex';
import Attachment from '../../molecules/message/Attachment';
const StyledParagraph = styled(Paragraph) `
    font-size: 16px;
    font-weight: 400;
    color: #6f6f6e;
`;
const Message = ({ name, role, text, initials, date, variant, id, attachments, }) => {
    return (_jsxs(Flex, { column: true, margin: "0 0 40px 0", children: [_jsx(Author, { name: name, role: role, initials: initials, variant: variant, date: date }), _jsx(StyledParagraph, { children: text }), attachments && (_jsx(Flex, { gap: '15px', flexWrap: 'wrap', children: attachments.map(attachment => {
                    const index = attachments.indexOf(attachment);
                    return (_jsx(Attachment, { href: `/dossierbericht/${id}/downloads/${index}`, fileName: attachment.original_file_name }));
                }) }))] }));
};
export default Message;
